/**
 * Application configuration settings
 * Using a dedicated config file allows for both environment variables
 * and fallback values, following our human-in-the-loop approach by providing
 * clear feedback when configuration is missing
 */

const config = {
  supabase: {
    url: process.env.REACT_APP_SUPABASE_URL || 'https://bzittncscxzzblhfdupk.supabase.co',
    anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ6aXR0bmNzY3h6emJsaGZkdXBrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc1NjQ2MDksImV4cCI6MjA1MzE0MDYwOX0.5GGMk0upL8z8JKnGcbP_W6H_-5OfkCgyQ2_c-2StQTY',
  }
};

// Debug information for configuration
console.log('=== Application Configuration ===');
console.log('Supabase URL:', config.supabase.url ? config.supabase.url.substring(0, 15) + '...' : 'MISSING');
console.log('Supabase Key set:', !!config.supabase.anonKey);

export default config;
